import { useState, useCallback } from 'react'
import { useToaster } from 'react-angle-dashboard-components'
import { groupService } from '../services'
import { useGbsContext } from '../store'
import { Actions } from '../store/actions'
import { GbsState } from '../store/interfaces'

export const useCaptureValue = (
  stepKey: keyof GbsState['steps'],
  data: any,
  stepValue?: any,
  opts: { plainValue: boolean } = { plainValue: false }
) => {
  // To treat the object as a primitive value
  const stringifyData = JSON.stringify(data)
  const stringifyOpts = JSON.stringify(opts)
  const { dispatch } = useGbsContext()
  const { show } = useToaster()
  const [isLoading, setLoading] = useState(false)

  const captureAnswer = useCallback(async () => {
    const payload = JSON.parse(stringifyData)
    const op = JSON.parse(stringifyOpts)

    try {
      setLoading(true)
      await groupService.modify(payload)
      dispatch({
        type: Actions.SetStepData,
        payload: {
          stepKey,
          stepData: op.plainValue ? stepValue : { value: stepValue } || payload
        }
      })
      setLoading(false)
      return true
    } catch (e: any) {
      setLoading(false)
      show({
        message: e.message || 'An unknown error occurred',
        type: 'danger'
      })
      return false
    }
  }, [stringifyData, stringifyOpts, dispatch, show, stepKey, stepValue])

  return {
    isLoading,
    captureAnswer
  }
}

export const useUpdateValue = (
  stepKey: keyof GbsState['steps'],
  opts: { plainValue: boolean } = { plainValue: false }
) => {
  // To treat the object as a primitive value
  const stringifyOpts = JSON.stringify(opts)
  const { dispatch } = useGbsContext()
  const { show } = useToaster()
  const [isLoading, setLoading] = useState(false)

  const updateValue = useCallback(
    async (stepValue, payload) => {
      const op = JSON.parse(stringifyOpts)
      try {
        setLoading(true)
        await groupService.modify(payload)
        dispatch({
          type: Actions.SetStepData,
          payload: {
            stepKey,
            stepData: op.plainValue
              ? stepValue
              : { value: stepValue } || payload
          }
        })
        setLoading(false)
        return true
      } catch (e: any) {
        setLoading(false)
        show({
          message: e.message || 'Something went wrong',
          icon: 'icon-cancel',
          type: 'danger'
        })
        return false
      }
    },
    [stringifyOpts, dispatch, show, stepKey]
  )

  return {
    isLoading,
    updateValue
  }
}
